import React, {Component} from 'react'
import {Button} from "antd"
import {exportItemCsv} from "../../../../services/api/3dApi"

class ExportBatchCSV extends Component {
    _handleExportCSV = () => {
        const {match, status} = this.props

        window.open(exportItemCsv(match.params.id, `status=${status}`))
    }

    render() {
        const {changeContent} = this.props

        return (
            <Button type="primary" icon='export' className="mr-3 mt-2"
                    disabled={changeContent}
                    onClick={this._handleExportCSV}>Xuất CSV</Button>
        )
    }

}

export default ExportBatchCSV
